var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchplaylistform"},[_c('AutoCompleteForm',{attrs:{"searchType":"playlist","filteredItems":_vm.value,"maxResult":"200","maxSelectable":"1"},on:{"select":_vm.onSelectPlaylist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }